export default __webpack_public_path__ + "static/media/Nexus.fd141876.png";